<template>
  <form-edit-activity :form-type="FORM_TYPE" ref="formEditor"
                      :mode="mode"
                      :entity-id="entityId"
                      @form-created="formCreated"
                      :context="context"
                      :toolbox-mixins="toolbox"
  >
  </form-edit-activity>
</template>

<script>

import Activity from "@/activity/Activity";
import PermissionsSet from "@/server/PermissionsSet";
import Rpc from "@/Rpc";
import FormsListActivity from "@/activity/templates/layouts/forms/FormsListActivity";
import FormsLoader from "@/components/forms/FormsLoader";

import FormEditActivity from "@/activity/templates/layouts/forms/FormEditActivity";
import FormMixin from "@/components/forms/customizations/mixins/FormMixin";
import ReachInput from "@/components/inputs/ReachInput";
import OrderDetails from "@/server/com/silkplm/model/plm/OrderDetails";
import CalculateBudgetingPlannerPMRecord from "@/components/forms/customizations/plm/CalculateBudgetingPlannerPMRecord";
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import Order from "@/server/com/silkplm/model/plm/Order";

const FORM_TYPE = OrderDetails;
const CALC_PLANNER_PM = new CalculateBudgetingPlannerPMRecord();

export default {
  name: "OrderDetailsEditor",
  components: {ReachInput, FormMixin, FormEditActivity, FormsListActivity},
  permission: () => FormsLoader.formPermission(FORM_TYPE),

  props: {
    entityId: {default: null},
    mode: {type: String, default: "NEW"},
    budgetingPlannerPM: {default: null},
    planning: {default: null},
    orderId: {default: null},
    orderClass: {default: null},
    context: {default: null},

  },

  async created() {
    if (this.mode === "NEW") {
      await this.loadInstancesInNewMode();
      await this.updateRow(this.budgetingPlannerPM);
      // nie usuwac poki co (fill computed fields i watche nie powinny byc juz potrzebne, bo wykonuja sie computed fields z javy)
      // await this.fillComputedFields();
    } else if (this.mode === "EDIT" && (!this.orderDetailsInstance || !this.productInSeasonInstance || !this.productInstance)) {
      await this.loadInstancesInEditMode();
    }

  },

  methods: {
    ...Activity.methods,

    /** @type {FormModel} form */
    async formCreated(form) {
      this.form = form;
    },

    async canClose() {
      return this.$refs.formEditor.canClose();
    },

    async loadInstancesInNewMode() {
      this.orderInstance = await Rpc.Forms.getEntity(this.orderClass, this.orderId);
      if (!this.orderInstance.orderForRawMaterials) {
        if (this.budgetingPlannerPM) {
          this.productInSeasonInstance = await this.budgetingPlannerPM.getProductIdEntity();
        } else if (this.planning) {
          this.productInSeasonInstance = await this.planning.getProductSeasonIdEntity();
        }
        this.productInstance = await this.productInSeasonInstance.getProductIdEntity();
      }
    },

    async loadInstancesInEditMode() {
      this.orderDetailsInstance = await Rpc.Forms.getEntity(this.formConfig.formClassLong, this.entityId);
      if (!this.orderInstance) {
        this.orderInstance = new Order();
        await this.orderInstance.load(this.orderDetailsInstance.orderId);
      }
      if (!this.orderInstance.orderForRawMaterials) {
        this.productInSeasonInstance = await this.orderDetailsInstance.getProductInSeasonIdEntity();
        this.productInstance = await this.productInSeasonInstance.getProductIdEntity();
      }
    },

    async updateRow(instance) {
      if (instance) {
        await CALC_PLANNER_PM.calculatePlannerWithProduct(instance);
      }
    },

    async exportBrandingReport() {
      let orderDetailsEntity = await Rpc.Forms.getEntity(this.formConfig.formClassLong, this.entityId);
      await Rpc.plm.services.BrandingService.generateDelayedReportForOrderDetails(orderDetailsEntity).lock();
    },

    async exportBrandingFolder() {
      let orderDetailsEntity = await Rpc.Forms.getEntity(this.formConfig.formClassLong, this.entityId).lock();
      await Rpc.plm.services.BrandingService.generateBrandingFolderForOrderDetails(orderDetailsEntity).lock();
    }
  },

  data: function () {
    let toolbox = [];
    if (this.entityId) {
      let exportBrandingReportButton = new ToolboxButton().withIcon("file-arrow-down").withLabel($tr("exportBrandingFolder", "Export Branding Folder"))
          .withAction((btn) => this.exportBrandingReport());
      toolbox.push(exportBrandingReportButton);
      let exportBrandingZipButton = new ToolboxButton().withIcon("folder-arrow-down").withLabel($tr("exportBrandingFolder", "Export Branding Folder"))
          .withAction((btn) => this.exportBrandingFolder());
      toolbox.push(exportBrandingZipButton);
    }

    return {
      FORM_TYPE,
      /** @type {FormModel} */
      form: null,
      readOnly: true,
      permissions: new PermissionsSet(),
      formConfig: FormsLoader.detectFormConfig(FORM_TYPE),
      formId: FormsLoader.detectFormConfig(FORM_TYPE).formId,
      orderInstance: null,
      productInSeasonInstance: null,
      ppSampleProductInstance: null,
      productInstance: null,
      toolbox: [...toolbox]
    }
  }
}
</script>
